import { useToast } from "@design";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";

export function useConnectionCallback(nameFor: (slug: string) => string | undefined, ready: boolean) {
  const [params, setParams] = useSearchParams();
  const toast = useToast();
  const { t } = useTranslation("settings");
  const handled = useRef(false);
  const connected = params.get("connected");
  const status = params.get("status");

  useEffect(() => {
    if (!connected || !ready || handled.current) return;
    handled.current = true;
    const name = nameFor(connected) ?? connected;
    if (status === "success") toast.success(t("connections.connectedToast", { name }));
    else toast.error(t("connections.connectFailedToast", { name }));
    setParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete("connected");
        next.delete("status");
        return next;
      },
      { replace: true },
    );
  }, [connected, status, ready, nameFor, setParams, t, toast]);
}
